import { render, staticRenderFns } from "./mall_config.vue?vue&type=template&id=ea2ead98&scoped=true"
import script from "./mall_config.vue?vue&type=script&lang=js"
export * from "./mall_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2ead98",
  null
  
)

export default component.exports